<template>
  <v-layout
    id='app'
    v-bind:class='{
      toolbarMobile: $route.meta.toolbarMobile !== false,
      footerMobile: $route.meta.footerMobile !== false,
      backArrow: $route.meta.backArrow !== false
    }'
  >
    <v-toolbar
      v-if='showHeader && $route.meta.toolbarMobile !== false'
      app
      class='only-mobile'
    >
      <v-btn v-if='backArrow' icon @click='goBack()'>
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title
        v-if='this.title' class='flex-grow'
      >{{ $t($route.meta.title) }}
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer> -->

      <v-btn
        icon
        flat
        color='transparent'
        class='profile-header-icon'
        @click='goBackChild()'
      >
        <img src='../assets/img/profile.png' alt='Profile avatar' v-if='!isChild' />
        <v-avatar v-if='isChild' class='active text-center categoria-header'>
          <i
            class='icon-3 icon i'
          ></i>
        </v-avatar>
      </v-btn>
    </v-toolbar>

    <v-navigation-drawer
      mobile-break-point='1025'
      class='theme--default'
      v-model='drawer'
      app
      fixed
      dark
      v-if='$route.meta.drawer !== false'
      width='250'
    >
      <div class='logo mt-5 mb-4'>
        <img src='../assets/img/logo-super-comics.png' alt='logo Super Comics' />
      </div>
      <v-list class='list-nav--default'>
        <template v-for='(m, i) in menu'>
          <v-list-tile :key='m.title' :to='{ name: m.route }'>
            <v-list-tile-action>
              <v-icon>{{ m.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class='text-uppercase'>
                {{ $t('drawer.layout.menu')[i] }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <div class='pb-3 mt-2'>
          <v-list-tile class='small' v-if='this.activeSubscription === true'>
            <hr />
          </v-list-tile>

          <v-list-tile class='small' v-if='this.activeSubscription === true'>
            <v-list-tile-action>
              <v-icon>lock_open</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ profile.login_type === 'venezuela' ? trackPlan(profile.idp) :
                $t('profile.manageSubscription')
                }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

<!--          <v-list-tile-->
<!--            class='small'-->
<!--            :to="{ name: 'Subscription' }"-->
<!--            v-else-if='!isChild'-->
<!--            v-on:click='trackAnalytics()'-->
<!--          >-->
<!--            <v-list-tile-action>-->
<!--              <v-icon>lock</v-icon>-->
<!--            </v-list-tile-action>-->
<!--            <v-list-tile-content>-->
<!--              <v-list-tile-title>{{-->
<!--                  $t('drawer.layout.subscribe')-->
<!--                }}-->
<!--              </v-list-tile-title>-->
<!--            </v-list-tile-content>-->
<!--          </v-list-tile>-->

          <v-list-tile
            class='venapSub'
            href='https://app.venapp.com/K2FE' target='_blank'
            v-if='profile.login_type === "venezuela" && profile.idp !== "plan:gold"'>
            <v-list-tile-action>
              <v-icon style='color: transparent'>lock</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class='textVenapp'>
                {{ trackSubscription(profile.idp) }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>


          <v-list-tile v-if='!isChild' class='small'>
            <hr />
          </v-list-tile>

          <div>
            <router-link
              v-if='!isChild'
              class='v-list__tile v-list__tile--link theme--dark'
              :to="{ name: 'PerfilEditar' }"
              v-bind:class="{
                'v-list__tile--active': $route.name.startsWith('Perfil')
              }"
            >
              <v-list-tile-action>
                <v-icon>face</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ formatNumber() }}</v-list-tile-title>
              </v-list-tile-content>
            </router-link>
            <router-link
              v-if='isChild'
              class='v-list__tile v-list__tile--link theme--dark'
              :to="{ name: 'PerfilInfantil' }"
              v-bind:class="{
                'v-list__tile--active': $route.name.startsWith('Perfil')
              }"
            >
              <v-list-tile-action>
                <v-icon>face</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ formatNumber() }}</v-list-tile-title>
              </v-list-tile-content>
            </router-link>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-content fluid fill-height>
      <v-progress-linear
        v-if='loading'
        v-bind:indeterminate='true'
        class='nomargin loading-main'
      ></v-progress-linear>
      <header-default v-if='$route.meta.header === true'></header-default>

      <transition name='slide-x-transition' mode='out-in'>
        <router-view :search='true'></router-view>
      </transition>

      <footer-mobile v-if='$route.meta.footerMobile !== false'></footer-mobile>
    </v-content>

    <v-snackbar
      :timeout='snackbar.timeout'
      :color='snackbar.color'
      :top="snackbar.y === 'top'"
      :bottom="snackbar.y === 'bottom'"
      v-model='snackbar.show'
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native='snackbar.show = false'>OK</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import HeaderDefault from '@/components/HeaderDefault';
import footerMobile from '@/components/footerMobile';
import { formatNumber } from 'libphonenumber-js';
import { analytics } from '@/main';

export default {
  props: {
    source: String
  },
  components: {
    'header-default': HeaderDefault,
    'footer-mobile': footerMobile
  },
  data() {
    return {
      W: window,
      backArrow: true,
      showHeader: true,
      snackbar: {
        show: false,
        text: '',
        color: 'primary',
        y: 'bottom',
        timeout: 2000
      },
      avatar: null,
      drawer: true,
      loading: true,
      title: this.$route.name || 'Super Comics',
      app: {
        android:
          'https://play.google.com/store/apps/details?id=com.zedlatam.supercomics',
        ios: 'https://itunes.apple.com/br/app/super-comics/id1327984849'
      },
      menu: [
        {
          icon: 'SC-home',
          title: 'INÍCIO',
          enable: true,
          route: 'Home'
        },
        {
          icon: 'SC-explore',
          title: 'EXPLORAR',
          enable: true,
          route: 'Explorar'
        },
        {
          icon: 'SC-search',
          title: 'BUSCAR',
          enable: true,
          route: 'Busca'
        },
        {
          icon: 'SC-library',
          title: 'FAVORITOS',
          enable: true,
          route: 'Favoritos'
        }
      ]
    };
  },
  created() {
    // eslint-disable-next-line no-undef
    axios.defaults.baseURL = __API__;
    axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
    axios.defaults.headers.common['api-version'] = '3';

    bus.$on('menu', val => {
      this.drawer = val;
    });
    bus.$on('loading', val => {
      this.loading = val;
    });
    bus.$on('snackbar', (text, color, timeout, y) => {
      this.snackbar.show = true;
      this.snackbar.text = text;
      this.snackbar.color =
        color === null || color == undefined ? 'primary' : color;
      this.snackbar.timeout =
        timeout === null || timeout == undefined ? 2000 : timeout;
      this.snackbar.y = y === null || y == undefined ? 'bottom' : y;
    });
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.getProfile();
    this.childProfile();
  },
  watch: {

    $route(to, from) {
      //to, from
      if (to.name === from.name) {
        bus.$emit('loading', false);
      }
      if (this.$store.getters.profile.login_type === 'venezuela') {
        if (to.name === 'Subscription') {
          window.open('https://app.venapp.com/K2FE', '_blank');
          window.history.back();
        }
      }
      this.backArrow = this.$route.meta.backArrow;
      this.title = this.$route.meta.title || this.$route.name;
    }
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    },
    token() {
      return this.$cookies.get('sctoken');
    },
    activeSubscription: function() {
      return this.$store.getters['activeSubscription'];
    },
    isChild() {
      return localStorage.getItem('password') === null ? false : true;
    }
  },
  methods: {
    trackAnalytics() {
      const { profile } = this.$store.getters;
      
      analytics.logEvent('subscribe_premiun', {
        id_user: this.$store.getters.profile.id,
        display_name: profile.display_name,
        email: profile.email,
        msisdn: profile.msisdn,
        name: profile.name,
        idp: profile.idp
      });
    },
    trackPlan(idp) {
      if (idp === 'plan:free') {
        return 'Nivel: Standard';
      } else if (idp === 'plan:normal') {
        return 'Nivel: Gold';
      } else if (idp === 'plan:gold') {
        return 'Nivel: Platinum';
      }
    },
    trackSubscription(idp) {
      if (idp === 'plan:free') {
        return 'Suscríbete Gold o Platinum';
      } else if (idp === 'plan:normal') {
        return 'Suscríbete Platinum';
      }
    },
    formatNumber() {
      if (this.profile && this.profile.display_name) {
        return this.profile.display_name;
      }

      return this.profile && this.profile.name
        ? this.profile.name
        : formatNumber('+' + this.profile.msisdn, 'International');
    },
    getProfile() {
      this.$store
        .dispatch('getProfile')
        .then(() => {
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
        });
    },
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        //this.$router.push('home')
        this.$router.push({
          name: 'Home'
        });
      }
    },
    handleResize() {
      this.drawer = window.innerWidth < 1025 ? false : true;
      this.backArrow = this.$route.meta.backArrow;
      this.showHeader = !this.drawer;
    },
    getMobileOperatingSystem() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        return 'Android';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }
      return 'unknown';
    },
    childProfile() {
      let isChild = localStorage.getItem('password') === null ? false : true;
      if (isChild) {
        this.menu[1].route = 'ExplorarChild';
      }
    },
    goBackChild() {
      this.getMobileOperatingSystem();
      setTimeout(() => {
        this.setMenuWidth();
      }, 25);
      window.onresize = () => {
        this.setMenuWidth();
      };
      //this.$router.push('home')
      this.$router.push({
        name: 'Perfil'
      });
    },
    setMenuWidth() {
      let colNavigator = document.querySelector('.profile-col-navigator');
      let menuInner = document.querySelector('.profile-menu-inner');
      menuInner.style.width = colNavigator.offsetWidth + 'px';
    }
  }
};
</script>

<style lang='scss'>
.v-snack {
  z-index: 999999999999999;
}

.profile-header-icon {
  padding: 5px;
  background-color: transparent !important;

  img {
    height: 36px;
    width: 36px;
    padding: 5px;
    border-radius: 18px;
  }

  i {
    height: 28px;
    width: 28px;
  }
}

.only-mobile {
  z-index: 100000;
  display: inline-block;
  box-shadow: none !important;

  @media only screen and (min-width: 1025px) {
    display: none;
  }

  background-color: rgba(#f5f5f8, 0.75) !important;
  -webkit-backdrop-filter: blur(10px) contrast(0.8);
  backdrop-filter: blur(10px) contrast(0.8);

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    //chrome fix
    background-color: rgba(#f5f5f8, 0.97) !important;
  }
}

.v-navigation-drawer {
  @media only screen and (max-width: 767px) {
    display: none;
  }
}

.menuNotifications {
  .v-list {
    padding: 0;

    .v-list__tile__title {
      font-weight: 500;
      font-size: 15px;
      color: #1d1d1d;
    }

    .v-list__tile__sub-title {
      font-size: 12px;
    }

    hr {
      margin: 0;
      width: 100%;
    }
  }
}
</style>
